import {
  Icon,
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';
import styled from 'styled-components';

import { Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import DividerLayoutComponent from '../../../../../../../core/layout-components/divider';

const Card = styled(SegmentLayoutComponent)`
  &.ui.segment {
    margin-bottom: 25px;
    padding: 20px;
  }
`;

const Title = styled(TextLayoutComponent.Header)`
`;

const Description = styled(TextLayoutComponent)`
  margin-bottom: 30px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Quote = styled.div`
  display: flex;
`;

const Content = styled.div`
  align-self: center;
  display: flex;
  flex-grow: 1;
`;

const Sentence = styled(TextLayoutComponent)`
  word-wrap: break-word;
`;

const LevelContainer = styled.div`
  align-items: center;
  display: flex;
  margin-left: 30px;
`;

const Level = styled(TextLayoutComponent.Label)`
  align-items: center;
  background: ${(props) => props.sentimentColor};
  border-radius: 2px;
  display: flex;
  font-weight: 500;
  height: 22px;
  justify-content: center;
  width: 90px;
`;

const Divider = styled(DividerLayoutComponent)`
`;

const ViewMore = styled.a`
  align-self: flex-end;
  display: flex;
  margin-right: 10px;
  margin-top: 30px;
`;

const RemoveIcon = styled(Icon).attrs(() => ({
  name: 'minus circle',
}))`
  color: red;
  cursor: pointer;
  padding-left: 10px;
`;

const NoQuotesMessage = styled.div`
  margin: auto;
`;

const FilterContainer = styled.div`
  display: flex;
  margin-bottom: 30px;
`;

const DescriptionContainer = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 10px;
`;

const DropdownContainer = styled.div`
`;

const Dropdown = styled(SemanticDropdown)`
  &.ui.dropdown > .text {
    color: ${(props) => props.theme.color.primary};
    font-weight: 500;
  }
`;

export {
  Card,
  Container,
  Content,
  Description,
  Divider,
  Dropdown,
  DropdownContainer,
  DescriptionContainer,
  FilterContainer,
  Level,
  LevelContainer,
  NoQuotesMessage,
  Quote,
  RemoveIcon,
  Sentence,
  Title,
  ViewMore,
};
